export const StatusEnum = {
  PENDING: {
    value: "PENDING",
    description: 'Pending Processing',
    color: 'rgb(254, 255, 196)',
    colorFamily: 'yellow',
  },
  GENERATING: {
    value: "GENERATING",
    description: 'Processing',
    color: 'rgb(255, 215, 196)',
    colorFamily: 'amber',
  },
  READY: {
    value: "READY",
    description: 'Ready for Review',
    color: 'rgb(196, 255, 211)',
    colorFamily: 'green',
  },
  INVALID: {
    value: "INVALID",
    description: 'Invalid',
    color: 'rgb(255, 140, 140)',
    colorFamily: 'red',
  },
  QUEUED_FOR_FILING: {
    value: "QUEUED_FOR_FILING",
    description: 'Queued for Filing',
    color: 'rgb(180, 220, 255)',
    colorFamily: 'blue',
  },
  FILED_AWAY: {
    value: "FILED_AWAY",
    description: 'Filed Away',
    color: 'rgb(230, 204, 255)',
    colorFamily: 'purple',
  },
  ASSIGNED: {
    value: "ASSIGNED",
    description: 'Assigned',
    color: 'rgb(255, 175, 255)',
    colorFamily: 'pink',
  },
  ASSIGNED_TO_OOO: {
    value: "ASSIGNED_TO_OOO",
    description: 'Out of office',
    color: 'rgb(255, 214, 165)',
    colorFamily: 'amber',
  },
  IN_REVIEW: {
    value: "IN_REVIEW",
    description: "In Review",
    color: "rgb(190, 234, 235)",
    colorFamily: 'teal',
  }
}; 